import { helper } from '@ember/component/helper';
import { assert } from '@ember/debug';
import { OperationLabels } from 'donor-elf-web/lib/filter-utils-new';

// usage: {{filter-query (filter 'firstName' operation='stringContains' val='yoder')}}
// usage: {{filter-query (filter 'contact_group' operation='any' val=(array 'Friend' 'Church'))}}
export default helper(function (params, namedArgs) {
  let propertyName = params[0];
  let operation = namedArgs.operation;
  let val = namedArgs.val;

  assert(
    `'${operation}' is not a valid filter operation`,
    operation == null || OperationLabels[operation] != null,
  );

  // convert val:string to val:string[] if it's an operation for a list
  if (operation === 'any' || operation === 'all' || operation === 'none') {
    if (typeof val === 'string') {
      val = [val];
    }
  }

  return {
    propertyName,
    operation,
    val,
  };
});
